import { configureStore } from '@reduxjs/toolkit'

import clinicSlice, {
    setClinics,
    setCurrentClinic,
    setCurrentClinicLocation,
    setCurrentClinicTitle,
    setCurrentClinicExcerpt,
    setCurrentClinicThumbnail,
} from './slices/clinicsSlice'
export {
    setClinics,
    setCurrentClinic,
    setCurrentClinicLocation,
    setCurrentClinicTitle,
    setCurrentClinicExcerpt,
    setCurrentClinicThumbnail,
}

const store = configureStore({
    reducer: {
        clinics: clinicSlice,
    },
})

export default store
